import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function ShieldCheckNotification({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><g clipPath="url(#clip0_8_40)"><path vectorEffect="non-scaling-stroke" d="M20 11V11.182C20 15.723 16.58 19.969 12 21C7.413 19.96 4 15.72 4 11.182V7.61504C4 6.79504 4.49 6.06504 5.24 5.75504L10.24 3.70504C11.1276 3.33255 12.1082 3.25527 13.0354 3.4732M15.25 10.125L11.5 13.875L9.25 11.625" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /><circle cx={20} cy={4} r={4} fill="#BBB0FF" /></g><defs><clipPath id="clip0_8_40"><rect width={24} height={24} fill="currentColor" /></clipPath></defs></Svg>;
}
export default ShieldCheckNotification;